import { GeoWidget } from '../core/GeoWidget';

class StyleEditor extends GeoWidget {

    constructor(config) {

        config = config || {};
        config.tip = config.tip || 'StyleEditor';
        config.title = config.title || 'Lista de camadas';
        config.class = config.class || 'gb-menu-control';
        config.docked = config.docked || true;
        config.hasUI = false;
        config.untitled = true;

        super(config);

        this._layersListGroup = null;
        this._fillPickr = null;
        this._strokePickr = null;
        this._strokeWidth = null;
        this._pointStrokeWidth = null;
        this._pointRadius = null;
        this._layerItem = null;
        this._layerOpacity = null;

        this._pointGroup = null;
        this._fillGroup = null;
        this._strokeGroup = null;


        this._hasUI = false;
        this.on('ready', () => {

            this._getLayers();
            this._initColorPicker();
            this._initLayerProps();
            this._handleInterface();
            this._registerEvents();

        });

    }

    initialize() {

        this._showInterface();

    }

    _buildUIPoint() {

        this._groupCircle = document.createElement('div');
        this._groupImage = document.createElement('div');


        //Row10
        let rowStyleType = document.createElement('div');
        rowStyleType.classList.add('gb-prop-row');

        let estilo = document.createElement('span');
        estilo.textContent = 'Estilo Ponto:';
        estilo.classList.add('gb-prop-name');

        let inputestilo = document.createElement('select');
        inputestilo.innerHTML += '<option value="circle">Círculo</option>';
        inputestilo.innerHTML += '<option value="image">Imagem</option>';
        inputestilo.classList.add('form-control');
        inputestilo.style.width = '148px';
        inputestilo.classList.add('gb-input-custom');
        inputestilo.id = 'inputestilo';
        this._estiloPonto = inputestilo;

        rowStyleType.appendChild(estilo);
        rowStyleType.appendChild(inputestilo);

        //Row 
        let propRow4 = document.createElement('div');
        propRow4.classList.add('gb-prop-row');

        let pointRadius = document.createElement('span');
        pointRadius.textContent = 'Raio do Ponto:';
        pointRadius.classList.add('gb-prop-name');

        let inputRadius = document.createElement('input');
        inputRadius.setAttribute('type', 'number');
        inputRadius.setAttribute('min', '0');
        inputRadius.classList.add('form-control');
        inputRadius.classList.add('gb-input-custom');
        inputRadius.style.width = '74px';
        inputRadius.id = 'inputRadius';
        this._pointRadius = inputRadius;

        propRow4.appendChild(pointRadius);
        propRow4.appendChild(inputRadius);




        //Row11
        let propRow11 = document.createElement('div');
        propRow11.classList.add('gb-prop-row');

        let xAncor = document.createElement('span');
        xAncor.textContent = 'Âncora X:';
        xAncor.classList.add('gb-prop-name');

        let inputxAncor = document.createElement('input');
        inputxAncor.setAttribute('type', 'number');
        inputxAncor.setAttribute('min', '0');
        inputxAncor.setAttribute('max', '100');
        inputxAncor.value = 0;
        inputxAncor.classList.add('form-control');
        inputxAncor.style.width = '74px';
        inputxAncor.classList.add('gb-input-custom');
        inputxAncor.id = 'inputxAncor';
        this._xAncor = inputxAncor;

        propRow11.appendChild(xAncor);
        propRow11.appendChild(inputxAncor);


        //Row12
        let propRow12 = document.createElement('div');
        propRow12.classList.add('gb-prop-row');

        let yAncor = document.createElement('span');
        yAncor.textContent = 'Âncora Y:';
        yAncor.classList.add('gb-prop-name');

        let inputyAncor = document.createElement('input');
        inputyAncor.setAttribute('type', 'number');
        inputyAncor.setAttribute('min', '0');
        inputyAncor.setAttribute('max', '100');
        inputyAncor.value = 0;
        inputyAncor.classList.add('form-control');
        inputyAncor.style.width = '74px';
        inputyAncor.classList.add('gb-input-custom');
        inputyAncor.id = 'inputyAncor';
        this._yAncor = inputyAncor;

        propRow12.appendChild(yAncor);
        propRow12.appendChild(inputyAncor);

        //Row13
        let propRow13 = document.createElement('div');
        propRow13.classList.add('gb-prop-row');

        let path = document.createElement('span');
        path.textContent = 'Ícone:';
        path.classList.add('gb-prop-name');

        let inputpath = document.createElement('input');
        inputpath.setAttribute('type', 'text');
        inputpath.classList.add('form-control');
        inputpath.style.width = '148px';
        inputpath.classList.add('gb-input-custom');
        inputpath.id = 'inputpath';
        this._path = inputpath;

        propRow13.appendChild(path);
        propRow13.appendChild(inputpath);

        //Icones
        this._iconConteiner = document.createElement('div');
        this._iconConteiner.style.position = 'absolute';
        this._iconConteiner.style.top = '2%';
        this._iconConteiner.style.left = '35%';
        this._iconConteiner.style.width = '500px';
        this._iconConteiner.style.padding = '10px';
        //this._iconConteiner.style.height = '500px';
        this._iconConteiner.style.zIndex = '999999';
        this._iconConteiner.style.background = '#fff';
        this._iconConteiner.style.display = 'none';

        document.body.appendChild(this._iconConteiner);

        this._pointGroup.appendChild(rowStyleType);
        ///this._pointGroup.appendChild(iconConteiner);
        this._groupCircle.appendChild(propRow4);
        this._pointGroup.appendChild(this._groupCircle);

        this._groupImage.appendChild(propRow11);
        this._groupImage.appendChild(propRow12);
        this._groupImage.appendChild(propRow13);
        this._pointGroup.appendChild(this._groupImage);
        this._groupImage.style.display = 'none';


    }

    _buildUIFill() {

        //Row 1

        let propRow = document.createElement('div');
        propRow.classList.add('gb-prop-row');

        let fillColor = document.createElement('span');
        fillColor.textContent = 'Cor de Preenchimento:';
        fillColor.classList.add('gb-prop-name');

        let colorSelector = document.createElement('div');
        colorSelector.id = 'colorPicker';

        propRow.appendChild(fillColor);
        propRow.appendChild(colorSelector);

        this._fillGroup.appendChild(propRow);

    }

    _buildUIStroke() {

        //Row 2

        let propRow2 = document.createElement('div');
        propRow2.classList.add('gb-prop-row');

        let strokeColor = document.createElement('span');
        strokeColor.textContent = 'Cor da Linha:';
        strokeColor.classList.add('gb-prop-name');

        let strokeSelector = document.createElement('div');
        strokeSelector.id = 'strokePicker';

        propRow2.appendChild(strokeColor);
        propRow2.appendChild(strokeSelector);

        //Row 3

        let propRow3 = document.createElement('div');
        propRow3.classList.add('gb-prop-row');

        let strokeWidth = document.createElement('span');
        strokeWidth.textContent = 'Largura da Linha:';
        strokeWidth.classList.add('gb-prop-name');

        let inputWidth = document.createElement('input');
        inputWidth.setAttribute('type', 'number');
        inputWidth.setAttribute('min', '0');
        inputWidth.classList.add('form-control');
        inputWidth.style.width = '74px';
        inputWidth.classList.add('gb-input-custom');
        inputWidth.id = 'sinputWidth';
        this._strokeWidth = inputWidth;

        propRow3.appendChild(strokeWidth);
        propRow3.appendChild(inputWidth);


        //Row9
        let propRow9 = document.createElement('div');
        propRow9.classList.add('gb-prop-row');

        let dash = document.createElement('span');
        dash.textContent = 'Traço da Linha:';
        dash.classList.add('gb-prop-name');

        let inputDash = document.createElement('input');
        inputDash.setAttribute('type', 'text');
        inputDash.classList.add('form-control');
        inputDash.style.width = '148px';
        inputDash.classList.add('gb-input-custom');
        inputDash.id = 'inputDash';
        this._dash = inputDash;

        propRow9.appendChild(dash);
        propRow9.appendChild(inputDash);

        //Row10
        let rowStyleType = document.createElement('div');
        rowStyleType.classList.add('gb-prop-row');

        let estilo = document.createElement('span');
        estilo.textContent = 'União da Linha:';
        estilo.classList.add('gb-prop-name');

        let inputestilo = document.createElement('select');
        inputestilo.innerHTML += '<option value="bevel">Chanfrada</option>';
        inputestilo.innerHTML += '<option value="round">Redonda</option>';
        inputestilo.innerHTML += '<option value="miter">Miter</option>';
        inputestilo.classList.add('form-control');
        inputestilo.style.width = '148px';
        inputestilo.classList.add('gb-input-custom');
        inputestilo.id = 'inputestilo';
        this._join = inputestilo;

        rowStyleType.appendChild(estilo);
        rowStyleType.appendChild(inputestilo);

        this._strokeGroup.appendChild(propRow2);
        this._strokeGroup.appendChild(propRow3);
        this._strokeGroup.appendChild(propRow9);
        this._strokeGroup.appendChild(rowStyleType);


    }

    _buildUILabel() {

        this._labelGroupToHide = document.createElement('div');

        // Mostar/Ocultar Label
        let propRow0 = document.createElement('div');
        propRow0.classList.add('gb-prop-row');

        let display = document.createElement('span');
        display.textContent = 'Mostrar Etiquetas:';
        display.classList.add('gb-prop-name');

        let checkDisplay = document.createElement('input');
        checkDisplay.setAttribute('type', 'checkbox');
        checkDisplay.classList.add('form-control');
        checkDisplay.style.width = '24px';
        checkDisplay.classList.add('gb-input-custom');
        this._label = checkDisplay;

        propRow0.appendChild(display);
        propRow0.appendChild(checkDisplay);

        // fonte
        let fontRow = document.createElement('div');
        fontRow.classList.add('gb-prop-row');

        let fonte = document.createElement('span');
        fonte.textContent = 'Fonte:';
        fonte.classList.add('gb-prop-name');

        let inputfonte = document.createElement('select');
        inputfonte.innerHTML += '<option value="Sans-serif">Arial</option>';
        inputfonte.innerHTML += '<option value="Serif">Times</option>';
        inputfonte.innerHTML += '<option value="Monospace">Courier</option>';
        inputfonte.classList.add('form-control');
        inputfonte.style.width = '148px';
        inputfonte.classList.add('gb-input-custom');
        inputfonte.id = 'inputfonte';
        this._fonte = inputfonte;

        fontRow.appendChild(fonte);
        fontRow.appendChild(inputfonte);

        //color
        let propRow = document.createElement('div');
        propRow.classList.add('gb-prop-row');

        let fillColor = document.createElement('span');
        fillColor.textContent = 'Cor da Fonte:';
        fillColor.classList.add('gb-prop-name');

        let colorSelector = document.createElement('div');
        colorSelector.id = 'fontColorPicker';

        propRow.appendChild(fillColor);
        propRow.appendChild(colorSelector);
    

        //tamanho
        let fontSizeRow = document.createElement('div');
        fontSizeRow.classList.add('gb-prop-row');

        let strokeWidth = document.createElement('span');
        strokeWidth.textContent = 'Tamanho da fonte';
        strokeWidth.classList.add('gb-prop-name');

        let inputWidth = document.createElement('input');
        inputWidth.setAttribute('type', 'number');
        inputWidth.setAttribute('min', '0');
        inputWidth.classList.add('form-control');
        inputWidth.style.width = '74px';
        inputWidth.classList.add('gb-input-custom');
        inputWidth.id = 'fontSize';
        this._fontSize = inputWidth;

        fontSizeRow.appendChild(strokeWidth);
        fontSizeRow.appendChild(inputWidth);

        //field
        let propRow13 = document.createElement('div');
        propRow13.classList.add('gb-prop-row');

        let path = document.createElement('span');
        path.textContent = 'Campo:';
        path.classList.add('gb-prop-name');

        let inputpath = document.createElement('input');
        inputpath.setAttribute('type', 'text');
        inputpath.classList.add('form-control');
        inputpath.style.width = '148px';
        inputpath.classList.add('gb-input-custom');
        inputpath.id = 'inputpath';
        this._field = inputpath;

        propRow13.appendChild(path);
        propRow13.appendChild(inputpath);


        this._labelGroup.appendChild(propRow0);
        this._labelGroup.appendChild(this._labelGroupToHide);
        this._labelGroupToHide.appendChild(fontRow);
        this._labelGroupToHide.appendChild(fontSizeRow);
        this._labelGroupToHide.appendChild(propRow);
        this._labelGroupToHide.appendChild(propRow13);


    }

    _handleLabelUi(){

        if(this._label.checked){

            this._labelGroupToHide.style.display = 'block';

        } else {

            this._labelGroupToHide.style.display = 'none';

        }

    }

    _showInterface() {

        this.map.hideAllControls();
        this.map.openDock('left', 35);
        this.map.mapElement.style.right = '0';

        let panel = this.map.getDock('left');
        panel.classList.add('gb-panel-content');
        panel.style.background = 'linear-gradient(to bottom, #464A5B 50%, #24303C)';

        let layersList = document.createElement('div');
        layersList.className = 'gb-layers-list-content';

        let layersStyle = document.createElement('div');
        layersStyle.className = 'gb-layer-style';



        /*
         *
         * Lista de Camadas
         *
         */

        let headerList = document.createElement('div');
        headerList.className = 'gb-header-list-content';

        let title = document.createElement('span');
        title.textContent = 'Lista das Camadas';
        title.className = 'gb-list-layers-title';

        let layersIcon = document.createElement('div');
        layersIcon.classList.add('gb-layers-icon');

        this._layersListGroup = document.createElement('ul');
        this._layersListGroup.classList.add('list-group');
        this._layersListGroup.classList.add('list-group-flush');

        headerList.appendChild(layersIcon);
        headerList.appendChild(title);
        layersList.appendChild(headerList);
        layersList.appendChild(this._layersListGroup);



        /*
         *
         * Estilo das Camadas
         *
         */

        let headerStyle = document.createElement('div');
        headerStyle.className = 'gb-header-style-content';

        let titleStyle = document.createElement('span');
        titleStyle.textContent = 'Estilo da Camada';
        titleStyle.className = 'gb-list-layers-title';
        titleStyle.classList.add('gb-color-green');

        let styleProps = document.createElement('div');
        styleProps.classList.add('gb-style-props');



        // Mostar/Ocultar Layer
        let propRow0 = document.createElement('div');
        propRow0.classList.add('gb-prop-row');

        let display = document.createElement('span');
        display.textContent = 'Mostrar:';
        display.classList.add('gb-prop-name');

        let checkDisplay = document.createElement('input');
        checkDisplay.setAttribute('type', 'checkbox');
        checkDisplay.classList.add('form-control');
        checkDisplay.style.width = '24px';
        checkDisplay.classList.add('gb-input-custom');
        this._display = checkDisplay;

        propRow0.appendChild(display);
        propRow0.appendChild(checkDisplay);


        // Controle da Opacidade
        let propRow8 = document.createElement('div');
        propRow8.classList.add('gb-prop-row');

        let spanOpacity = document.createElement('span');
        spanOpacity.textContent = 'Opacidade:';
        spanOpacity.classList.add('gb-prop-name');

        let inputOpacity = document.createElement('input');
        inputOpacity.setAttribute('type', 'number');
        inputOpacity.setAttribute('min', '0');
        inputOpacity.setAttribute('max', '100');
        inputOpacity.classList.add('form-control');
        inputOpacity.classList.add('gb-input-custom');
        inputOpacity.style.width = '74px';
        inputOpacity.id = 'inputOpacity';
        this._layerOpacity = inputOpacity;

        propRow8.appendChild(spanOpacity);
        propRow8.appendChild(inputOpacity);



        /*
         *
         * Cria os elementos para a manipulação dos estilos
         *
         */
        this._pointGroup = document.createElement('div');
        this._fillGroup = document.createElement('div');
        this._strokeGroup = document.createElement('div');
        this._labelGroup = document.createElement('div');

        this._buildUIPoint();
        this._buildUIFill();
        this._buildUIStroke();
        this._buildUILabel();



        /*
         *
         * Monta a interface
         *
         */
        headerStyle.appendChild(titleStyle);
        layersStyle.appendChild(headerStyle);
        layersStyle.appendChild(styleProps);

        styleProps.appendChild(propRow0);
        styleProps.appendChild(this._pointGroup);
        styleProps.appendChild(this._fillGroup);
        styleProps.appendChild(this._strokeGroup);
        styleProps.appendChild(this._labelGroup);
        styleProps.appendChild(propRow8);

        panel.appendChild(layersList);
        panel.appendChild(layersStyle);

        this._getIcons();

    }

    _getIcons() {

        let path = 'https://cdn.jsdelivr.net/npm/@mapbox/maki@6.1.0/icons/';
        let icons = ['aerialway', 'airfield', 'airport', 'alcohol-shop', 'american-football', 'amusement-park', 'aquarium', 'art-gallery', 'attraction', 'bakery', 'bank', 'bar', 'barrier', 'baseball', 'basketball', 'bbq', 'beach', 'beer', 'bicycle', 'bicycle-share', 'blood-bank', 'bowling-alley', 'bridge', 'building', 'building-alt1', 'bus', 'cafe', 'campsite', 'car', 'car-rental', 'car-repair', 'casino', 'castle', 'cemetery', 'charging-station', 'cinema', 'circle', 'circle-stroked', 'city', 'clothing-store', 'college', 'commercial', 'communications-tower', 'confectionery', 'convenience', 'cricket', 'cross', 'dam', 'danger', 'defibrillator', 'dentist', 'doctor', 'dog-park', 'drinking-water', 'embassy', 'emergency-phone', 'entrance', 'entrance-alt1', 'farm', 'fast-food', 'fence', 'ferry', 'fire-station', 'fitness-centre', 'florist', 'fuel', 'furniture', 'gaming', 'garden', 'garden-centre', 'gift', 'globe', 'golf', 'grocery', 'hairdresser', 'harbor', 'hardware', 'heart', 'heliport', 'home', 'horse-riding', 'hospital', 'ice-cream', 'industry', 'information', 'jewelry-store', 'karaoke', 'landmark', 'landuse', 'laundry', 'library', 'lighthouse', 'lodging', 'logging', 'marker', 'marker-stroked', 'mobile-phone', 'monument', 'mountain', 'museum', 'music', 'natural', 'optician', 'paint', 'park', 'park-alt1', 'parking', 'parking-garage', 'pharmacy', 'picnic-site', 'pitch', 'place-of-worship', 'playground', 'police', 'post', 'prison', 'rail', 'rail-light', 'rail-metro', 'ranger-station', 'recycling', 'religious-buddhist', 'religious-christian', 'religious-jewish', 'religious-muslim', 'residential-community', 'restaurant', 'restaurant-noodle', 'restaurant-pizza', 'restaurant-seafood', 'roadblock', 'rocket', 'school', 'scooter', 'shelter', 'shoe', 'shop', 'skateboard', 'skiing', 'slaughterhouse', 'slipway', 'snowmobile', 'soccer', 'square', 'square-stroked', 'stadium', 'star', 'star-stroked', 'suitcase', 'sushi', 'swimming', 'table-tennis', 'teahouse', 'telephone', 'tennis', 'theatre', 'toilet', 'town', 'town-hall', 'triangle', 'triangle-stroked', 'veterinary', 'viewpoint', 'village', 'volcano', 'volleyball', 'warehouse', 'waste-basket', 'watch', 'water', 'waterfall', 'watermill', 'wetland', 'wheelchair', 'windmill', 'zoo'];
        for (let i = 0; i < icons.length; i++) {
            this._iconConteiner.innerHTML += `<img class="gb-editor-point-image" style="padding: 5px; cursor: pointer;" src="${path}${icons[i]}-15.svg">`;
        }

    }

    _getLayers() {

        for (let i = 0; i < this.map.content.length; i++) {
            if (this.map.content[i].type.toLowerCase() == 'ogc' || this.map.content[i].type.toLowerCase() == 'baselayer') {

                for (let j = 0; j < this.map.content[i].layers.length; j++) {
                    let layer = document.createElement('a');
                    layer.classList.add('list-group-item');
                    layer.classList.add('list-group-item-action');
                    layer.setAttribute('i', i);
                    layer.setAttribute('j', j);
                    layer.classList.add('gb-list-group-item');
                    if (i == 0 && j == 0) {
                        layer.classList.add('gb-layer-item-active');
                        this._layerItem = layer;
                    }
                    layer.text = this.map.content[i].name + ': ' + this.map.content[i].layers[j].name;
                    this._layersListGroup.appendChild(layer);
                }

            }
        }

    }

    _initColorPicker() {

        let i = this._layerItem.getAttribute('i');
        let j = this._layerItem.getAttribute('j');

        let layer = this.map.content[i].layers[j];

        this._fillPickr = Pickr.create({
            el: '#colorPicker',
            theme: 'nano',
            default: layer.style.fill ? layer.style.fill.color : '#fff',
            position: 'right',
            components: {
                preview: true,
                opacity: true,
                hue: true,
                interaction: {
                    hex: true,
                    rgba: true,
                    hsla: true,
                    input: true,
                    save: true
                }
            }
        });

        this._strokePickr = Pickr.create({
            el: '#strokePicker',
            theme: 'nano',
            default: layer.style.stroke ? layer.style.stroke.color : '#000',
            position: 'right-end',
            components: {
                preview: true,
                opacity: true,
                hue: true,
                interaction: {
                    hex: true,
                    rgba: true,
                    hsla: true,
                    input: true,
                    save: true
                }
            }
        });

        this._fontColorPickr = Pickr.create({
            el: '#fontColorPicker',
            theme: 'nano',
            default: layer.style.fill ? layer.style.fill.color : '#fff',
            position: 'right',
            components: {
                preview: true,
                opacity: true,
                hue: true,
                interaction: {
                    hex: true,
                    rgba: true,
                    hsla: true,
                    input: true,
                    save: true
                }
            }
        });

    }

    _initLayerProps() {

        let i = this._layerItem.getAttribute('i');
        let j = this._layerItem.getAttribute('j');

        let layer = this.map.content[i].layers[j];
        this._display.checked = layer.display;

        if (layer.primitive === 'point') {

            if (layer.style.image) {

                this._xAncor.value = layer.style.image.anchor[0];
                this._yAncor.value = layer.style.image.anchor[0];
                this._path.value = layer.style.image.src;

            } else if (layer.style.circle) {

                this._fillPickr.setColor(layer.style.fill.color, false);
                this._strokePickr.setColor(layer.style.stroke.color, false);
                this._strokeWidth.value = layer.style.stroke.width;
                this._pointRadius.value = layer.style.circle.radius;
                this._dash.value = layer.style.stroke.lineDash ? layer.style.stroke.lineDash.join(',') : '1';
                this._join.value = layer.style.stroke.lineJoin || 'round';

            }

            // Hide/Show elements
            if (layer.style.circle) {

                this._estiloPonto.value = 'circle';

            } else if (layer.style.image) {

                this._estiloPonto.value = 'image';

            }

            this._handlePointUI();

        } else if (layer.primitive === 'line') {

            this._strokePickr.setColor(layer.style.stroke.color, false);
            this._strokeWidth.value = layer.style.stroke.width;
            this._dash.value = layer.style.stroke.lineDash ? layer.style.stroke.lineDash.join(',') : '1';
            this._join.value = layer.style.stroke.lineJoin || 'round';

        }

        else if (layer.primitive === 'polygon') {

            this._fillPickr.setColor(layer.style.fill.color, false);
            this._strokePickr.setColor(layer.style.stroke.color, false);
            this._strokeWidth.value = layer.style.stroke.width;
            this._dash.value = layer.style.stroke.lineDash ? layer.style.stroke.lineDash.join(',') : '1';
            this._join.value = layer.style.stroke.lineJoin || 'round';

        }

         // Hide/Show elements
         if (layer.style.label) {

            this._label.checked = true;
            this._fonte.value = layer.style.label.font || 'Sans-serif';
            this._fontSize.value = layer.style.label.size || '12';
            this._fontColorPickr.setColor(layer.style.label.color, false);
            this._field.value = layer.style.label.text;

        } else {

            this._label.checked = false;
            this._fonte.value = 'Sans-serif';
            this._fontSize.value = '12';
            this._fontColorPickr.setColor('#000', false);
            this._field.value = '';

        }

        this._handleLabelUi();
        

        this._layerOpacity.value = layer.style.opacity * 100;



    }

    _handlePointUI() {

        let i = this._layerItem.getAttribute('i');
        let j = this._layerItem.getAttribute('j');

        if (this._estiloPonto.value === 'circle') {

            this._groupCircle.style.display = 'block';
            this._groupImage.style.display = 'none';
            this._fillGroup.style.display = 'block';
            this._strokeGroup.style.display = 'block';



        } else if (this._estiloPonto.value === 'image') {

            this._groupCircle.style.display = 'none';
            this._groupImage.style.display = 'block';
            this._fillGroup.style.display = 'none';
            this._strokeGroup.style.display = 'none';

        }

        if (this._changeStylePoint) {

            if (this.map.content[i].layers[j].style.circle) {

                delete this.map.content[i].layers[j].style.circle;
                delete this.map.content[i].layers[j].style.stroke;
                delete this.map.content[i].layers[j].style.fill;
                this.map.content[i].layers[j].style.image = {};

            } else if (this.map.content[i].layers[j].style.image) {

                delete this.map.content[i].layers[j].style.image;
                this.map.content[i].layers[j].style.stroke = {};
                this.map.content[i].layers[j].style.fill = {};
                this.map.content[i].layers[j].style.circle = {};

            }
            this._changeStylePoint = false;
        }

    }

    _handleInterface() {

        let i = this._layerItem.getAttribute('i');
        let j = this._layerItem.getAttribute('j');
        let layer = this.map.content[i].layers[j];

        if (layer.primitive === 'point') {

            this._handlePointUI();
            this._pointGroup.style.display = 'block';

        } else if (layer.primitive === 'line') {

            this._pointGroup.style.display = 'none';
            this._fillGroup.style.display = 'none';
            this._strokeGroup.style.display = 'block';

        } else if (layer.primitive === 'polygon') {

            this._pointGroup.style.display = 'none';
            this._fillGroup.style.display = 'block';
            this._strokeGroup.style.display = 'block';

        } else if (layer.primitive === 'raster') {

            this._pointGroup.style.display = 'none';
            this._fillGroup.style.display = 'none';
            this._strokeGroup.style.display = 'none';
            this._labelGroup.style.display = 'none';

        }

        if (layer.primitive !== 'raster') {

            this._labelGroup.style.display = 'block';

        }

    }

    _registerEvents() {

        this._display.addEventListener('change', () => {

            let i = this._layerItem.getAttribute('i');
            let j = this._layerItem.getAttribute('j');

            this.map.content[i].layers[j].display = this._display.checked;
            this.map._removeAllLayers();
            this.map._drawLayers();

        });

        this._fillPickr.on('change', (color) => {
            this._fillPickr.applyColor(true);
            let i = this._layerItem.getAttribute('i');
            let j = this._layerItem.getAttribute('j');

            this.map.content[i].layers[j].style.fill.color = color.toRGBA().toString(1);
            this.map.updateStyle();
            this.map.content[i].layers[j].modifiedStyle = true;
        });

        this._strokePickr.on('change', (color) => {
            this._strokePickr.applyColor(true);
            let i = this._layerItem.getAttribute('i');
            let j = this._layerItem.getAttribute('j');

            this.map.content[i].layers[j].style.stroke.color = color.toRGBA().toString(1);
            this.map.updateStyle();
            this.map.content[i].layers[j].modifiedStyle = true;
        });

        this._pointRadius.addEventListener('change', () => {
            let i = this._layerItem.getAttribute('i');
            let j = this._layerItem.getAttribute('j');

            this.map.content[i].layers[j].style.circle.radius = this._pointRadius.value;
            this.map.updateStyle();
            this.map.content[i].layers[j].modifiedStyle = true;
        });

        this._strokeWidth.addEventListener('change', () => {
            let i = this._layerItem.getAttribute('i');
            let j = this._layerItem.getAttribute('j');

            this.map.content[i].layers[j].style.stroke.width = this._strokeWidth.value;
            this.map.updateStyle();
            this.map.content[i].layers[j].modifiedStyle = true;
        });

        this._layerOpacity.addEventListener('change', () => {
            let i = this._layerItem.getAttribute('i');
            let j = this._layerItem.getAttribute('j');

            this.map.content[i].layers[j].style.opacity = (this._layerOpacity.value / 100);
            this.map.updateStyle();
            this.map.content[i].layers[j].modifiedStyle = true;
        });

        let layers = document.getElementsByClassName('gb-list-group-item');
        Array.from(layers).forEach((element) => {
            element.addEventListener('click', () => {
                this._layerItem.classList.remove('gb-layer-item-active');
                element.classList.add('gb-layer-item-active');
                this._layerItem = element;
                this._handleInterface();
                this._initLayerProps();
            });
        });

        this._estiloPonto.addEventListener('change', () => {
            this._handlePointUI();
        });

        this._estiloPonto.addEventListener('click', () => {
            this._changeStylePoint = true;
        });

        this._xAncor.addEventListener('change', () => {
            let i = this._layerItem.getAttribute('i');
            let j = this._layerItem.getAttribute('j');

            this.map.content[i].layers[j].style.image.anchor[0] = this._xAncor.value;
            this.map.updateStyle();
            this.map.content[i].layers[j].modifiedStyle = true;

        });

        this._yAncor.addEventListener('change', () => {
            let i = this._layerItem.getAttribute('i');
            let j = this._layerItem.getAttribute('j');

            this.map.content[i].layers[j].style.image.anchor[1] = this._xAncor.value;
            this.map.updateStyle();
            this.map.content[i].layers[j].modifiedStyle = true;

        });



        this._path.addEventListener('change', () => {
            let i = this._layerItem.getAttribute('i');
            let j = this._layerItem.getAttribute('j');

            this.map.content[i].layers[j].style.image.src = this._path.value;
            this.map.updateStyle();
            this.map.content[i].layers[j].modifiedStyle = true;

        });

        this._path.addEventListener('focus', () => {

            this._iconConteiner.style.display = 'block';
            this._iconConteiner.style.top = this._path.offsetTop + 'px';

            let images = document.getElementsByClassName(' gb-editor-point-image');
            Array.from(images).forEach((element) => {
                element.addEventListener('click', () => {

                    let i = this._layerItem.getAttribute('i');
                    let j = this._layerItem.getAttribute('j');

                    this._path.value = element.src;
                    this.map.content[i].layers[j].style.image.src = element.src;
                    this.map.updateStyle();
                    this.map.content[i].layers[j].modifiedStyle = true;


                });
            });

        });

        this._iconConteiner.addEventListener('click', () => {

            this._iconConteiner.style.display = 'none';

        });

        this._dash.addEventListener('change', () => {
            let i = this._layerItem.getAttribute('i');
            let j = this._layerItem.getAttribute('j');

            this.map.content[i].layers[j].style.stroke.lineDash = this._dash.value.split(',').map(Number);
            this.map.updateStyle();
            this.map.content[i].layers[j].modifiedStyle = true;

        });

        this._join.addEventListener('change', () => {
            let i = this._layerItem.getAttribute('i');
            let j = this._layerItem.getAttribute('j');

            this.map.content[i].layers[j].style.stroke.lineJoin = this._join.value;
            this.map.updateStyle();
            this.map.content[i].layers[j].modifiedStyle = true;

        });

        this._label.addEventListener('change', () => {

            this._handleLabelUi();

        });

        this._label.addEventListener('change', () => {

            let i = this._layerItem.getAttribute('i');
            let j = this._layerItem.getAttribute('j');

            if(this._label.checked){

                this.map.content[i].layers[j].style.label = {};
                this.map.content[i].layers[j].style.label.font ='Sans-serif';
                this.map.content[i].layers[j].style.label.size = '12';
                this.map.content[i].layers[j].style.label.color =  '#000';

            } else {

                delete this.map.content[i].layers[j].style.label;
            }

            this.map.updateStyle();
            this.map.content[i].layers[j].modifiedStyle = true;

        });


        this._fonte.addEventListener('change', () => {

            let i = this._layerItem.getAttribute('i');
            let j = this._layerItem.getAttribute('j');

           
            this.map.content[i].layers[j].style.label.font =  this._fonte.value;

            this.map.updateStyle();
            this.map.content[i].layers[j].modifiedStyle = true;

        });

        this._fontSize.addEventListener('change', () => {

            let i = this._layerItem.getAttribute('i');
            let j = this._layerItem.getAttribute('j');

           
            this.map.content[i].layers[j].style.label.size =  this._fontSize.value;

            this.map.updateStyle();
            this.map.content[i].layers[j].modifiedStyle = true;

        });

        this._fontColorPickr.on('change', (color) => {

            this._fontColorPickr.applyColor(true);
            let i = this._layerItem.getAttribute('i');
            let j = this._layerItem.getAttribute('j');

            this.map.content[i].layers[j].style.label.color = color.toRGBA().toString(1);
            this.map.updateStyle();
            this.map.content[i].layers[j].modifiedStyle = true;
        });

        this._field.addEventListener('change', () => {

            let i = this._layerItem.getAttribute('i');
            let j = this._layerItem.getAttribute('j');

           
            this.map.content[i].layers[j].style.label.text =  this._field.value;

            this.map.updateStyle();
            this.map.content[i].layers[j].modifiedStyle = true;

        });


    }

}

export { StyleEditor };
